import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
const { PROCEDURE_15 } = environment;

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  constructor(private http: HttpClient) { }



  getInfoSeguimiento(id: any): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Tracking/${id}`);
  }

  GetInfoTramitesByUser(id: any): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/ProcedureRequest/GetAllByUser/${id}`);
  }


  saveTracking(tracking: any): Observable<any> {
    return this.http.post(`${PROCEDURE_15}/Tracking`, tracking);
  }

  addFieldsOfAction(camposAccion: any): Observable<any> {
    return this.http.post(`${PROCEDURE_15}/Tracking/AddFieldsOfAction`, camposAccion);
  }
}
